module.exports = __webpack_public_path__ + "img/a69.c9930fb4.png";